const createJaDeviceHelpQaSections = (platform) => {
  const isAndroid = platform === 'android'

  return [
    {
      title: '一、デバイスの接続と管理',
      items: [
        {
          title: '1.デバイスを追加',
          paragraphs: [
            'ホーム画面右上の【デバイスを追加】、または「マイページ - 設定 - デバイス管理」をタップし、デバイスがネットワーク設定モードになっていることを確認してください（デバイスの電源ボタンを2回押し、Wi-Fiアイコンが表示されるまで待ちます）。画面の案内に従って「スマートフォンをデバイスに接続」「デバイスのネットワークを設定」の手順を完了し、デジタルライフを作成／注入してください。'
          ]
        },
        {
          title: '2.スマートフォンをデバイスに接続',
          questions: [
            {
              title: '2.1 スマートフォンをデバイスに接続する際に「デバイスが見つかりません」と表示される',
              paragraphs: [
                isAndroid
                  ? 'デバイスがネットワーク設定モードになっているかご確認ください（デバイスの電源ボタンを2回押し、Wi-Fiアイコンが表示されるまで待ちます）。また、デバイスとスマートフォンの距離が10m以内であることを確認し、【再スキャン】をタップしてください。'
                  : 'デバイスがネットワーク設定モードになっているかご確認ください（デバイスの電源ボタンを2回押しし、Wi-Fiアイコンが表示されるまで待ちます）。また、デバイスとスマートフォンの距離が10m以内であることを確認し、【再スキャン】をタップしてください。'
              ]
            },
            {
              title: '2.2 スマートフォンをデバイスに接続する際に「デバイスへの接続に失敗しました」と表示される',
              paragraphs: [
                'サービスのタイムアウトによる一時的な異常の可能性があります。デバイスをネットワーク設定モードのままにして、【もう一度試す】をタップしてください。'
              ]
            }
          ]
        },
        {
          title: '3.デバイスのネットワークを設定',
          paragraphs: [
            '「ネットワーク設定」とは、スマートフォンアプリ（Fuzozoフゾゾ）でハードウェアデバイスにWi-Fiネットワークを追加することを指します。現在、1台のデバイスには最大10件のWi-Fiネットワークを追加できます。'
          ],
          questions: [
            {
              title: '3.1 新しいデバイスを初めてネットワーク設定する',
              paragraphs: isAndroid
                ? [
                    '「1.デバイスを追加」の手順を参考に、「スマートフォンをデバイスに接続」を完了すると、そのまま「デバイスのネットワークを設定」の画面に進みます。画面にはスマートフォンが現在接続しているWi-Fi名がデフォルトで表示されるため、パスワードを手動で入力すると、そのWi-Fiにデバイスを接続できます。 ほかのWi-Fiネットワークをデバイスに追加したい場合は、画面上でWi-Fi名とパスワードを手動入力する方法（より簡単です）、またはWi-Fi名の右側にある「Wi-Fiを切り替える」ボタンをタップしてシステム画面へ移動し、Wi-Fi一覧から接続したいWi-Fiを選んでパスワードを入力してください。'
                  ]
                : [
                    '「1.デバイスを追加」の手順を参考に、「スマートフォンをデバイスに接続」を完了すると、そのまま「デバイスのネットワークを設定」の画面に進みます。画面にはスマートフォンが現在接続しているWi-Fi名がデフォルトで表示されるため、パスワードを手動で入力すると、そのWi-Fiにデバイスを接続できます。',
                    'ほかのWi-Fiネットワークをデバイスに追加したい場合は、画面上でWi-Fi名とパスワードを手動入力する方法（より簡単です）、またはWi-Fi名の右側にある「Wi-Fiを切り替える」ボタンをタップしてシステム画面へ移動し、Wi-Fi一覧から接続したいWi-Fiを選んでパスワードを入力してください。'
                  ]
            },
            {
              title: '3.2 ネットワークの追加に失敗する',
              paragraphs: isAndroid
                ? [
                    '失敗の原因として、Wi-Fiパスワードの誤り、ネットワーク異常、デバイスがネットワーク設定モードを終了している、サービスのタイムアウトなどが考えられます。再度ネットワーク設定モードに入り、【もう一度試す】（Wi-Fiパスワードに誤りがないことを確認済みの場合）または【ネットワークを再選択】をタップしてください。 なお、現在のデバイスは2.4GHz Wi-Fiのみ対応しています。この周波数帯以外のWi-Fiネットワークには接続できません。'
                  ]
                : [
                    '失敗の原因として、Wi-Fiパスワードの誤り、ネットワーク異常、デバイスがネットワーク設定モードを終了している、サービスのタイムアウトなどが考えられます。再度ネットワーク設定モードに入り、【もう一度試す】（Wi-Fiパスワードに誤りがないことを確認済みの場合）または【ネットワークを再選択】をタップしてください。',
                    'なお、現在のデバイスは2.4GHz Wi-Fiのみ対応しています。この周波数帯以外のWi-Fiネットワークには接続できません。'
                  ]
            },
            {
              title: '3.3 すでに連携済みのデバイスに別のネットワークを追加する',
              paragraphs: isAndroid
                ? [
                    'ホーム画面右上の「デバイス管理-ネットワーク設定」または「マイページ-設定-デバイス管理-ネットワーク設定」ボタンをタップし、上記3.1、3.2を参考に操作してください。 また、この手順ではスマートフォンのテザリングも利用できます。アクセスポイント名とパスワードを入力することで、デバイスをインターネットに接続できます（操作中はテザリングをオンのままにしてください）。これにより、Wi-Fi環境がない場所でも、スマートフォンのテザリング共有を使ってハードウェアデバイスをオンラインにできます。'
                  ]
                : [
                    'ホーム画面右上の「デバイス管理-ネットワーク設定」または「マイページ-設定-デバイス管理-ネットワーク設定」ボタンをタップし、上記3.1、3.2を参考に操作してください。',
                    'また、この手順ではスマートフォンのテザリングも利用できます。アクセスポイント名とパスワードを入力することで、デバイスをインターネットに接続できます（操作中はテザリングをオンのままにしてください）。これにより、Wi-Fi環境がない場所でも、スマートフォンのテザリング共有を使ってハードウェアデバイスをオンラインにできます。'
                  ]
            }
          ]
        },
        {
          title: '4.デバイスとデジタルライフ',
          paragraphs: [
            'ハードウェアデバイスは、初回連携時にデジタルライフを作成するか注入するかを必ず選択する必要があります。1台のハードウェアデバイスに同時に連携できるデジタルライフは1体のみですが、連携解除後は別のデジタルライフを新たに作成または注入できます。'
          ],
          linkText: 'デジタルライフに関する詳細はこちら——>'
        },
        {
          title: '5.フゾゾと会話する',
          paragraphs: [
            '会話には「マオマオ語での会話」（ウェイクワード：モフモフ）と「地球語での会話」（ウェイクワード：ねぇ フゾゾ）の2つのモードがあり、オンライン状態でウェイクワードを話しかけることで開始できます。'
          ],
          questions: [
            {
              title: '5.1 ウェイクワードを話しても会話できない',
              paragraphs: [
                '考えられる原因： -（1）ネットワークに接続されていません。ネットワークをご確認いただくか、デバイスのネットワーク設定を行ってください。 -（2）アカウントまたはデジタルライフが連携されていません。App（Fuzozoフゾゾ）でデバイスの連携（追加）を完了してください。 -（3）スタミナが不足しています。会話にはスタミナを消費するため、スタミナが0の場合は会話状態に入れません。 -（4）この能力をまだ習得していません。「タスク-報酬」で人類言語での会話能力を習得し、その報酬を受け取ると地球語モードに入れるようになります。'
              ]
            },
            {
              title: '5.2 会話中に、フゾゾが急に反応しなくなった（表情が出ない・話さない）',
              paragraphs: [
                '考えられる原因： -（1）ネットワーク異常です。ネットワークをご確認ください。 -（2）フゾゾが周囲の雑音により中断されました。'
              ]
            }
          ]
        }
      ]
    },
    {
      title: '二、スタミナおよび関連サービス',
      items: [
        {
          title: '1.スタミナとは？何に使いますか？',
          paragraphs: [
            '音声インタラクションでは、ASR+RTC+LLM+TTSを利用するため、サーバーコストが発生します。そのため、スタミナは音声インタラクションにおける消費リソースとして設定されています。',
            'インタラクション時の消費：1分ごとにスタミナを5消費します。スタミナが0になると、インタラクションを続けられません。',
            '回復の仕組み：毎日午前4時に自動的に100ポイント（プレミアム付き添いプランでは300ポイント）を返信します。'
          ]
        }
      ]
    },
    {
      title: '三、タスクと報酬',
      items: [
        {
          title: '1.タスクはどこで確認できますか？',
          paragraphs: [
            '「ホーム-成長報酬」から、その日のタスクリストを確認できます。初心者タスクの有効期限は7日間、デイリータスクの有効期限は当日中です。タスクの期限が切れると、達成状況にかかわらずタスクリストが更新されます。'
          ]
        },
        {
          title: '2.報酬はどうやって解放されますか？',
          paragraphs: isAndroid
            ? [
                '報酬は、ユーザーとフゾゾの親密度が上がるにつれて順次解放されます。解放後は、ユーザーが手動で受け取ることで、システムから報酬が配布されます。 親密度の上げ方：',
                '1.タスクを達成する',
                '2.フゾゾとより多くの物理的インタラクションや音声インタラクションを行う'
              ]
            : [
                '報酬は、ユーザーとフゾゾの親密度が上がるにつれて順次解放されます。解放後は、ユーザーが手動で受け取ることで、システムから報酬が配布されます。',
                '親密度の上げ方：',
                '1.タスクを達成する',
                '2.フゾゾとより多くの物理的インタラクションや音声インタラクションを行う'
              ]
        }
      ]
    },
    {
      title: '四、フレンドサークル',
      items: [
        {
          title: '1.フゾゾに友だちを追加するには？',
          paragraphs: [
            'タッチして友だち追加：2体のフゾゾの左右をぴったりくっつけ、「ピン」という音が聞こえたら手を離してください（2体ともオンライン状態で、かつデジタルライフが連携済みである必要があります。そうでない場合、友だち追加は失敗します）。'
          ]
        },
        {
          title: '2.友だちとどうやって交流しますか？',
          paragraphs: isAndroid
            ? [
                'つんつん：App（Fuzozoフゾゾ）のフレンドサークル画面で、友だち一覧にある対象のフゾゾの右側に表示される「つんつん」ボタンをタップできます。 タッチ：友だち追加に成功したフゾゾ同士は、タッチ操作も行えます。「タッチ」の回数を累積し、マオマオ語でのやり取りが発生します。 （さらに多くの遊び方も、どうぞお楽しみに……）'
              ]
            : [
                'つんつん：App（Fuzozoフゾゾ）のフレンドサークル画面で、友だち一覧にある対象のフゾゾの右側に表示される「つんつん」ボタンをタップできます。',
                'タッチ：友だち追加に成功したフゾゾ同士は、タッチ操作も行えます。「タッチ」の回数を累積し、マオマオ語でのやり取りが発生します。',
                '（さらに多くの遊び方も、どうぞお楽しみに……）'
              ]
        }
      ]
    }
  ]
}

const jaDeviceHelpQaIosSections = createJaDeviceHelpQaSections('ios')
const jaDeviceHelpQaAndroidSections = createJaDeviceHelpQaSections('android')

export default {
  'zh-CN': {
    deviceHelpQa: {
      title: '帮助 QA',
      updatedLines: ['更新日期：2025年5月30日', '生效日期：2025年5月30日'],
      sections: [
        {
          title: '设备连接与管理',
          items: [
            {
              title: '1. 添加设备',
              paragraphs: [
                '点击首页右上角“添加设备”或“我的 - 设置 - 设备管理”，确保设备进入配网模式（双击设备电源键按钮，直至呈现 Wi-Fi 图标），按提示完成“手机连接设备”“为设备配置网络”几个步骤，并创建或注入数字生命。'
              ]
            },
            {
              title: '2. 手机连接设备',
              questions: [
                {
                  title: '2.1 手机连接设备时“未扫描到设备”',
                  paragraphs: [
                    '请检查设备是否在配网模式下（双击设备电源键按钮，直至呈现 Wi-Fi 图标），并确保设备和手机距离在 10m 内，然后点击“重新扫描”。'
                  ]
                },
                {
                  title: '2.2 手机连接设备时“连接设备失败”',
                  paragraphs: [
                    '可能为服务超时造成的异常，请保持设备处于配网模式下，并点击“再试一次”。'
                  ]
                }
              ]
            },
            {
              title: '3. 为设备配置网络',
              paragraphs: [
                '“配置网络”是指在手机 App（Fuzozo 芙崽）上为硬件设备添加 Wi-Fi 网络，当前设备支持最多添加 10 个 Wi-Fi 网络。'
              ],
              questions: [
                {
                  title: '3.1 新设备首次配置网络',
                  paragraphs: [
                    '参考“1. 添加设备”的步骤，完成“手机连接设备”后，即进入“为设备配置网络”的过程，页面默认获取手机当前连接的 Wi-Fi 名称，手动输入密码后即可为设备连接该 Wi-Fi 网络。',
                    '若需为设备添加其他 Wi-Fi 网络，可在页面手动输入 Wi-Fi 昵称和密码（操作更为便捷），或点击 Wi-Fi 名称右侧的“切换 Wi-Fi”按钮，跳转至系统，在 Wi-Fi 列表中选择需要连接的 Wi-Fi 并输入密码。'
                  ]
                },
                {
                  title: '3.2 添加网络失败',
                  paragraphs: [
                    '失败原因可能为：Wi-Fi 密码错误、网络异常、设备已退出配网模式、服务超时等异常原因。请重新进入配网模式，点击“再试一次”（当确认 Wi-Fi 密码填写无误），或点击“重新选网”。',
                    '请注意，当前设备仅支持使用 2.4Ghz Wi-Fi，若非该频段 Wi-Fi 网络亦无法成功连接。'
                  ]
                },
                {
                  title: '3.3 为已绑定设备配置更多网络',
                  paragraphs: [
                    '点击首页右上角“设备管理 - 配置网络”或“我的 - 设置 - 设备管理 - 配置网络”按钮，参照上述 3.1、3.2 部分进行操作。'
                  ],
                  note: '请注意，手机个人热点也可通过该流程输入热点名称和密码的方式实现设备上网功能（操作过程中请保持个人热点打开），从而支持硬件设备在无 Wi-Fi 环境下通过手机热点共享进行上网。'
                }
              ]
            },
            {
              title: '4. 设备与数字生命',
              paragraphs: [
                '硬件设备必须在首次绑定时选择创建或者注入数字生命，一个硬件同一时间只能绑定一条数字生命，但解绑后可重新创建或注入其他数字生命。'
              ],
              linkText: '查看更多关于数字生命的问题 ->'
            },
            {
              title: '5. 和芙崽对话',
              paragraphs: [
                '对话分为“毛毛语对话”（唤醒词：你好，芙崽）和“地球语对话”（唤醒词：灵光一现）两种模式，可在在线状态下通过唤醒词进入。'
              ],
              questions: [
                {
                  title: '5.1 喊出唤醒词，仍无法对话？',
                  paragraphs: [
                    '可能原因：（1）没有网络，请检查网络或为设备配网；（2）没有绑定账号、数字生命，请通过 App（Fuzozo 芙崽）完成绑定（添加）设备；（3）精力值不足，对话需要消耗精力值，当精力值为 0，则无法进入对话状态；（4）该能力未学会，需经过“任务 - 奖励”学会人类语言对话能力并领取该奖励后才可进入地球语模式。'
                  ]
                },
                {
                  title: '5.2 对话过程中，芙崽突然无反应（无表情、不说话）？',
                  paragraphs: [
                    '可能原因：（1）网络异常，请检查网络；（2）芙崽被其他杂音打断。'
                  ]
                }
              ]
            }
          ]
        },
        {
          title: '任务与奖励',
          items: [
            {
              title: '1. 如何查看任务？',
              paragraphs: [
                '通过“首页 - 成长奖励”进入，可查看当天的任务列表。新手任务有效期为 7 天，日常任务有效期为当天，任务过期后无论是否完成将刷新任务列表。'
              ]
            },
            {
              title: '2. 如何解锁奖励？',
              paragraphs: [
                '奖励会随着用户与芙崽的亲密度提升而逐步解锁，解锁后需用户手动领取后，系统下发奖励。',
                '亲密度提升：1. 可通过完成任务；2. 与芙崽进行更多物理交互及语音交互的互动。'
              ]
            }
          ]
        },
        {
          title: '好友圈',
          items: [
            {
              title: '1. 如何为芙崽添加好友？',
              paragraphs: [
                '碰一碰加好友：将两个芙崽两侧紧贴，当听到“叮”的声音，即可松手（需两只芙崽均处于联网状态且已绑定数字生命，否则交友失败）。'
              ]
            },
            {
              title: '2. 如何与好友互动？',
              paragraphs: [
                '戳一戳：可在 App（Fuzozo 芙崽）的好友圈页面，点击好友列表中对应的芙崽好友右侧的“戳”按钮。',
                '碰一碰：成功成为好友的芙崽，亦可进行碰一碰操作，累计“碰碰”次数，并触发毛毛语讨论。',
                '（更多玩法，敬请期待……）'
              ]
            }
          ]
        }
      ],
      contactPrefix: '其他帮助：如需进一步协助，可将问题发送至：',
      contactEmail: 'support{\'@\'}fuzozo.net'
    }
  },
  en: {
    deviceHelpQa: {
      title: 'Help Q&A',
      updatedLines: ['Updated: May 30, 2025', 'Effective: May 30, 2025'],
      sections: [
        {
          title: 'Device Connection and Management',
          items: [
            {
              title: '1. Adding a Device',
              paragraphs: [
                'Tap Add Device in the top-right corner of the home page, or go to Mine > Settings > Device Management. Make sure the device enters network configuration mode by double-pressing the power button until the Wi-Fi icon appears. Then follow the prompts to complete Connect Phone to Device, Configure Network for Device, and create or inject a Digital Life.'
              ]
            },
            {
              title: '2. Connecting Your Phone to the Device',
              questions: [
                {
                  title: '2.1 "No device detected" while connecting your phone',
                  paragraphs: [
                    'Please check whether the device is in network configuration mode by double-pressing the power button until the Wi-Fi icon appears. Also make sure the device and your phone are within 10 meters, then tap Rescan.'
                  ]
                },
                {
                  title: '2.2 "Failed to connect to device" while connecting your phone',
                  paragraphs: [
                    'This may be caused by a service timeout. Keep the device in network configuration mode and tap Try Again.'
                  ]
                }
              ]
            },
            {
              title: '3. Configuring Network for the Device',
              paragraphs: [
                'Configure Network means adding a Wi-Fi network for the hardware device in the Fuzozo app. The device currently supports up to 10 Wi-Fi networks.'
              ],
              questions: [
                {
                  title: '3.1 First-time network setup for a new device',
                  paragraphs: [
                    'Follow the steps in "1. Adding a Device". After Connect Phone to Device is completed, you will enter Configure Network for Device. The page will default to the Wi-Fi name currently connected on your phone. Enter the password to connect the device to that Wi-Fi network.',
                    'If you need to add another Wi-Fi network for the device, you can manually enter the Wi-Fi name and password for quicker setup, or tap the Switch Wi-Fi button next to the Wi-Fi name to jump to the system Wi-Fi list, choose the target network, and enter the password.'
                  ]
                },
                {
                  title: '3.2 Failed to add a network',
                  paragraphs: [
                    'Possible reasons include an incorrect Wi-Fi password, network issues, the device exiting network configuration mode, or a service timeout. Please re-enter network configuration mode and tap Try Again if the Wi-Fi password is correct, or tap Select Network Again.',
                    'Please note that the device currently supports only 2.4 GHz Wi-Fi. Networks on other bands cannot be connected successfully.'
                  ]
                },
                {
                  title: '3.3 Configuring more networks for a bound device',
                  paragraphs: [
                    'Tap Device Management > Configure Network from the top-right corner of the home page, or Mine > Settings > Device Management > Configure Network, and then follow sections 3.1 and 3.2 above.'
                  ],
                  note: 'Please note that a mobile hotspot can also be used in this flow by entering the hotspot name and password while keeping the hotspot turned on. This allows the hardware device to access the internet through your phone when no Wi-Fi network is available.'
                }
              ]
            },
            {
              title: '4. Device and Digital Life',
              paragraphs: [
                'When a hardware device is bound for the first time, you must choose to either create or inject a Digital Life. One hardware device can be bound to only one Digital Life at a time, but after unbinding, you can create or inject a different Digital Life again.'
              ],
              linkText: 'See more questions about Digital Life ->'
            },
            {
              title: '5. Talking with Fuzozo',
              paragraphs: [
                'There are two conversation modes: Fluff Language Conversation (wake phrase: "Hello, Fuzozo") and Earth Language Conversation (wake phrase: "Flash of Inspiration"). When the device is online, you can enter these modes with the corresponding wake phrase.'
              ],
              questions: [
                {
                  title: '5.1 Still unable to talk after saying the wake phrase?',
                  paragraphs: [
                    'Possible reasons: (1) no network connection, so please check the network or configure one for the device; (2) no account or Digital Life has been bound yet, so please bind or add the device through the Fuzozo app; (3) insufficient energy, since conversations consume energy and the device cannot enter conversation mode when energy is 0; (4) this ability has not been learned yet, so you must learn the human-language conversation ability through Tasks > Rewards and claim the reward before Earth Language mode becomes available.'
                  ]
                },
                {
                  title: '5.2 Why does Fuzozo suddenly stop responding during a conversation, with no expression or speech?',
                  paragraphs: [
                    'Possible reasons: (1) network issues, so please check the connection; (2) Fuzozo was interrupted by surrounding noise.'
                  ]
                }
              ]
            }
          ]
        },
        {
          title: 'Tasks and Rewards',
          items: [
            {
              title: '1. How can I view tasks?',
              paragraphs: [
                'Enter through Home > Growth Rewards to view the task list for the day. Beginner tasks remain valid for 7 days, while daily tasks are valid only for the current day. Once a task expires, the task list will refresh whether it has been completed or not.'
              ]
            },
            {
              title: '2. How do I unlock rewards?',
              paragraphs: [
                'Rewards are gradually unlocked as the bond between you and Fuzozo grows. After a reward is unlocked, you need to claim it manually before the system delivers it.',
                'Bond growth comes from: 1. completing tasks; 2. engaging in more physical and voice interactions with Fuzozo.'
              ]
            }
          ]
        },
        {
          title: 'Friends Circle',
          items: [
            {
              title: '1. How do I add friends for Fuzozo?',
              paragraphs: [
                'Add friends by touching devices together: place two Fuzozo devices closely side by side, and when you hear the "ding" sound, release them. Both devices must be online and already bound to a Digital Life, otherwise the friend request will fail.'
              ]
            },
            {
              title: '2. How do I interact with friends?',
              paragraphs: [
                'Poke: In the Friends Circle page of the Fuzozo app, tap the Poke button next to the corresponding Fuzozo friend in the friend list.',
                'Bump: After two Fuzozo become friends successfully, they can also bump into each other to accumulate bump counts and trigger Fluff Language discussions.',
                '(More gameplay is coming soon...)'
              ]
            }
          ]
        }
      ],
      contactPrefix: 'Need more help? If you need further assistance, please send your question to:',
      contactEmail: 'support{\'@\'}fuzozo.net'
    }
  },
  ja: {
    deviceHelpQa: {
      title: 'ヘルプQ&A',
      updatedLines: ['更新日：2025年5月30日', '発効日：2025年5月30日'],
      sections: jaDeviceHelpQaIosSections,
      platformSections: {
        ios: jaDeviceHelpQaIosSections,
        android: jaDeviceHelpQaAndroidSections
      },
      contactTitle: 'その他のヘルプ',
      contactPrefix: 'さらにサポートが必要な場合は、以下までお問い合わせください：',
      contactEmail: 'support{\'@\'}fuzozo.jp'
    }
  },
  'zh-TW': {
    deviceHelpQa: {
      title: '幫助 QA',
      updatedLines: ['更新日期：2025年5月30日', '生效日期：2025年5月30日'],
      sections: [
        {
          title: '設備連線與管理',
          items: [
            {
              title: '1. 新增設備',
              paragraphs: [
                '點擊首頁右上角的「新增設備」或「我的 - 設定 - 設備管理」，確保設備進入配網模式（雙擊設備電源鍵按鈕，直到出現 Wi-Fi 圖示），依照提示完成「手機連接設備」「為設備配置網路」等步驟，並建立或注入數位生命。'
              ]
            },
            {
              title: '2. 手機連接設備',
              questions: [
                {
                  title: '2.1 手機連接設備時顯示「未掃描到設備」',
                  paragraphs: [
                    '請檢查設備是否處於配網模式（雙擊設備電源鍵按鈕，直到出現 Wi-Fi 圖示），並確認設備與手機距離在 10m 內，然後點擊「重新掃描」。'
                  ]
                },
                {
                  title: '2.2 手機連接設備時顯示「連接設備失敗」',
                  paragraphs: [
                    '可能是服務逾時導致的異常，請保持設備處於配網模式，並點擊「再試一次」。'
                  ]
                }
              ]
            },
            {
              title: '3. 為設備配置網路',
              paragraphs: [
                '「配置網路」是指在手機 App（Fuzozo 芙崽）上為硬體設備新增 Wi-Fi 網路，當前設備最多支援新增 10 個 Wi-Fi 網路。'
              ],
              questions: [
                {
                  title: '3.1 新設備首次配置網路',
                  paragraphs: [
                    '參考「1. 新增設備」的步驟，完成「手機連接設備」後，即可進入「為設備配置網路」流程。頁面會預設取得手機目前連接的 Wi-Fi 名稱，手動輸入密碼後即可讓設備連接該 Wi-Fi 網路。',
                    '若需為設備新增其他 Wi-Fi 網路，可在頁面手動輸入 Wi-Fi 名稱和密碼（操作更便利），或點擊 Wi-Fi 名稱右側的「切換 Wi-Fi」按鈕，跳轉到系統 Wi-Fi 清單中選擇要連接的 Wi-Fi 並輸入密碼。'
                  ]
                },
                {
                  title: '3.2 新增網路失敗',
                  paragraphs: [
                    '失敗原因可能包括：Wi-Fi 密碼錯誤、網路異常、設備已退出配網模式、服務逾時等。請重新進入配網模式，在確認 Wi-Fi 密碼正確的情況下點擊「再試一次」，或點擊「重新選網」。',
                    '請注意，當前設備僅支援 2.4Ghz Wi-Fi，若不是該頻段的 Wi-Fi 網路，也無法成功連接。'
                  ]
                },
                {
                  title: '3.3 為已綁定設備配置更多網路',
                  paragraphs: [
                    '點擊首頁右上角的「設備管理 - 配置網路」或「我的 - 設定 - 設備管理 - 配置網路」按鈕，並參照上述 3.1、3.2 的步驟進行操作。'
                  ],
                  note: '請注意，手機個人熱點也可透過此流程輸入熱點名稱和密碼來實現設備上網功能（操作過程中請保持個人熱點開啟），從而支援硬體設備在沒有 Wi-Fi 的環境下，透過手機熱點分享來連線上網。'
                }
              ]
            },
            {
              title: '4. 設備與數位生命',
              paragraphs: [
                '硬體設備在首次綁定時必須選擇建立或注入數位生命。一台硬體設備同一時間只能綁定一條數位生命，但解除綁定後可重新建立或注入其他數位生命。'
              ],
              linkText: '查看更多關於數位生命的問題 ->'
            },
            {
              title: '5. 和芙崽對話',
              paragraphs: [
                '對話分為「毛毛語對話」（喚醒詞：你好，芙崽）和「地球語對話」（喚醒詞：靈光一現）兩種模式，可在在線狀態下透過喚醒詞進入。'
              ],
              questions: [
                {
                  title: '5.1 喊出喚醒詞後，仍然無法對話？',
                  paragraphs: [
                    '可能原因：（1）沒有網路，請檢查網路或為設備配網；（2）尚未綁定帳號或數位生命，請透過 App（Fuzozo 芙崽）完成設備綁定（新增）；（3）精力值不足，對話需要消耗精力值，當精力值為 0 時，無法進入對話狀態；（4）尚未學會該能力，需要透過「任務 - 獎勵」學會人類語言對話能力並領取該獎勵後，才可進入地球語模式。'
                  ]
                },
                {
                  title: '5.2 對話過程中，芙崽突然沒有反應（沒有表情、不說話）？',
                  paragraphs: [
                    '可能原因：（1）網路異常，請檢查網路；（2）芙崽被其他雜音打斷。'
                  ]
                }
              ]
            }
          ]
        },
        {
          title: '任務與獎勵',
          items: [
            {
              title: '1. 如何查看任務？',
              paragraphs: [
                '可透過「首頁 - 成長獎勵」進入查看當天的任務清單。新手任務有效期為 7 天，日常任務有效期為當天，任務到期後不論是否完成都會刷新任務清單。'
              ]
            },
            {
              title: '2. 如何解鎖獎勵？',
              paragraphs: [
                '獎勵會隨著使用者與芙崽的親密度提升而逐步解鎖，解鎖後需要使用者手動領取，系統才會發放獎勵。',
                '親密度提升方式：1. 透過完成任務；2. 與芙崽進行更多肢體互動及語音互動。'
              ]
            }
          ]
        },
        {
          title: '好友圈',
          items: [
            {
              title: '1. 如何為芙崽新增好友？',
              paragraphs: [
                '碰一碰加好友：將兩隻芙崽兩側緊貼，當聽到「叮」的聲音後即可鬆手（需兩隻芙崽都處於連網狀態且已綁定數位生命，否則加好友會失敗）。'
              ]
            },
            {
              title: '2. 如何與好友互動？',
              paragraphs: [
                '戳一戳：可在 App（Fuzozo 芙崽）的好友圈頁面，點擊好友清單中對應芙崽好友右側的「戳」按鈕。',
                '碰一碰：成功成為好友的芙崽，也可以進行碰一碰操作，累積「碰碰」次數，並觸發毛毛語討論。',
                '（更多玩法，敬請期待……）'
              ]
            }
          ]
        }
      ],
      contactPrefix: '其他幫助：如需進一步協助，可將問題寄送至：',
      contactEmail: 'support{\'@\'}fuzozo.net'
    }
  }
}
